<template>
  <div>
    <div :class="{ menu: true }">
      <div v-if="mobile">
        <div class="select">
          Choose a characteristic to map.
        </div>
        <select @change="selected">
          <optgroup
            v-for="(sublist, i) in variables"
            :key="'optgroup' + i"
            :label="headers[i]"
          >
            <option
              v-for="v in sublist"
              :key="'option' + v.key"
              :value="v.key"
              >{{ v.display }}</option
            >
          </optgroup>
        </select>
      </div>
      <div v-else>
        <div v-for="(sublist, i) in variables" :key="'sublist' + i">
          <div :class="{ row: true, wrap: width < 800 }">
            <div class="header">{{ headers[i] }}</div>
            <div
              :class="{ button: true, active: currentVariable === v.key }"
              v-for="v in sublist"
              :key="v.key"
              @click="clicked(v.key)"
            >
              {{ v.display }}
            </div>
          </div>
          <!-- <div class="descriptions">
          <div
          class="description"
            v-for="v in sublist.filter((v) => v.key === currentVariable)"
            :key="v.key + 'desc'"
          >
            {{ v.description }}
          </div>
        </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "underscore";

export default {
  name: "Menu",
  props: {
    currentVariable: String,
    variables: Array,
    headers: Array,
    width: Number,
  },
  data() {
    return {
      dropdown: false,
    };
  },
  computed: {
    mobile() {
      return this.width < 800;
    },
    currentVariableFull() {
      return _.flatten(this.variables).filter(
        (v) => v.key == this.currentVariable
      )[0];
    },
  },
  methods: {
    clicked(v) {
      this.$emit("click", v);
      this.dropdown = false;
    },
    selected(e) {
      this.clicked(e.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "plumber-sass/_plumber.scss";
@import "@/constants/_style.scss";

.menu {
  position: absolute;
  z-index: 1;
  right: 40px;
  background-color: rgba(255, 255, 255, 0.7);
  top: 0px;
  right: 0px;
  left: 0px;
  padding: $grid;
  padding-bottom: 4px;
  padding-right: 40px;

  .row {
    display: flex;
    margin-bottom: 8px;
    align-items: center;

    &.wrap {
      flex-wrap: wrap;
    }
  }

  .header {
    font-weight: bold;
    font-size: 14px;
    margin-right: 8px;
    text-shadow: 0px 0px 2px white;
    width: 100px;
    flex-shrink: 0;
  }

  .button {
    box-sizing: border-box;
    border: 1px solid gray;
    margin-right: 8px;
    padding: 8px;
    cursor: pointer;
    opacity: 0.8;
    background-color: white;

    &:hover {
      opacity: 1;
    }

    &.active {
      background-color: rgb(157, 205, 224);
      font-weight: bold;
    }

    // font-family: soleil;
    font-weight: 500;
    font-size: 12px;
  }
}

.mini {
  font-size: 14px;
  margin-top: -8px;
  padding-bottom: 8px;
  display: flex;
}

.select {
  font-weight: bold;
  margin-bottom: 4px;
  margin-top: -4px;
}

.title {
  font-weight: bold;
}

select {
  width: calc(100% - 40px);
}
</style>
